import React from "react"

import { SxProps } from "@mui/material"
import { styled } from "@mui/material/styles"

import { ChipType } from "./constants/ChipType"
import { MuiIcon } from "../MuiIcon"

interface IProps {
  title: string,
  active?: boolean,
  onClick?: () => void,
  sx?: SxProps,
  type?: ChipType,
  className?: string,
  disableOnHover?: boolean
}

export const Chip = ({
                       title,
                       active = false,
                       type = ChipType.default,
                       className = "",
                       ...props
                     }: IProps) => {

  const hoverDisabledClass = props.disableOnHover ? "hover-disabled" : ""
  const activeClass = active ? "active" : ""

  return <StyledChip
    className={`${type} ${activeClass} ${className} ${hoverDisabledClass}`}
    {...props}>
    <MuiIcon.Check sx={{ fontSize: "18px" }} />
    {title}
  </StyledChip>
}

const StyledChip = styled("div")({
  display: "flex",
  minWidth: "94px",
  alignItems: "center",
  height: "32px",
  border: "1px solid #79747E",
  color: "#1A1A1A",
  fontWeight: 600,
  fontSize: "12px",
  padding: "6px 16px",
  justifyContent: "center",
  borderRadius: "6px",
  cursor: "pointer",
  maxWidth: "122px",
  transition: "background .2s ease-in",

  "&.default": {
    background: "#fff",

    "&.active": {
      background: "#F2F2F2"
    },

    "&:hover, &.hover": {
      background: "#F2F2F2"
    }
  },

  "&.blue": {
    background: "#E7E9EB",

    "&.active": {
      background: "#94A6D0"
    },

    "&:hover, &.hover": {
      background: "#C1CAE0"
    }
  },

  "&.yellow": {
    background: "#FFF9C8",

    "&.active": {
      background: "#D9C18D"
    },

    "&:hover, &.hover": {
      background: "#F8DCAC"
    }
  },

  "& .MuiSvgIcon-root": {
    position: "absolute",
    opacity: 0
  },

  "&.active": {
    border: "none",
    paddingLeft: "6px",

    "& .MuiSvgIcon-root": {
      position: "relative",
      opacity: 1,
      marginRight: "8px",
      transition: "all .2s ease-in"
    }
  },

  "&.hover-disabled": {
    pointerEvents: "none"
  }

})
